<template>
  <div class="container">
    <div class="tile">
      <div class="tile-content">

        <form class="form-horizontal" v-on:submit="save">
          <div class="form-group">
            <div class="columns">
            <div class="col-3 col-md-12">
              <label class="form-label">{{question.text}}</label>
            </div>
            <div class="col-4 col-md-12">
              <div class="input-group">
                <select class="form-select" v-model="answer.atxt" @blur="save" style="width:100%;">
                  <option value="">Select a language</option>
                  <option value="6513A">Acehnese</option>
                  <option value="7999E">Achang</option>
                  <option value="9201A">Acholi</option>
                  <option value="8601A">Adnymathanha (Yura Ngawarla)</option>
                  <option value="9299AY">Afar</option>
                  <option value="4100B">Afghan</option>
                  <option value="9299A">African Languages, nec</option>
                  <option value="9200A">African Languages, nfd</option>
                  <option value="1403A">Afrikaans</option>
                  <option value="9203A">Akan</option>
                  <option value="3901A">Albanian</option>
                  <option value="8201A">Alyawarr (Alyawarra)</option>
                  <option value="9101A">American Languages</option>
                  <option value="9214A">Amharic</option>
                  <option value="8101A">Anindilyakwa</option>
                  <option value="8202A">Anmatyerr (Anmatyirra)</option>
                  <option value="9299AQ">Anuak</option>
                  <option value="8602A">Arabana (Arabuna)</option>
                  <option value="4202A">Arabic (Including Lebanese)</option>
                  <option value="9299AM">Arabic, Sudanese Creole</option>
                  <option value="6999C">Arakanese</option>
                  <option value="3902A">Armenian</option>
                  <option value="3903A">Aromunian (Macedo-Romanian)</option>
                  <option value="8203A">Arrente (Aranda)</option>
                  <option value="9204A">Asante</option>
                  <option value="4100C">Ashkun</option>
                  <option value="5213A">Assamese</option>
                  <option value="4203A">Assyrian</option>
                  <option value="4206A">Assyrian Neo-Aramaic</option>
                  <option value="9701A">Auslan</option>
                  <option value="8700A">Australian Creoles (NFD)</option>
                  <option value="8000A">Australian Indigenous/Aboriginal (NFD)</option>
                  <option value="4302A">Azeri</option>
                  <option value="6514A">Balinese</option>
                  <option value="4104A">Balochi</option>
                  <option value="3100A">Baltic, nfd</option>
                  <option value="8204A">Bardi</option>
                  <option value="9299H">Bari</option>
                  <option value="2901A">Basque</option>
                  <option value="9299I">Bassa</option>
                  <option value="3401A">Belorussian</option>
                  <option value="9215A">Bemba</option>
                  <option value="9299AD">Bembe</option>
                  <option value="5201A">Bengali</option>
                  <option value="6515A">Bikol</option>
                  <option value="6501A">Bisaya/Visaya</option>
                  <option value="9402A">Bislama</option>
                  <option value="3501A">Bosnian</option>
                  <option value="3502A">Bulgarian</option>
                  <option value="8205A">Bunuba (Bunaba)</option>
                  <option value="8102A">Burarra</option>
                  <option value="6100A">Burmese and Related Languages</option>
                  <option value="7101A">Cantonese</option>
                  <option value="8399A">Cape York Pen Aboriginal (NEC)</option>
                  <option value="8300A">Cape York Pen Aboriginal (NFD)</option>
                  <option value="2301A">Catalan</option>
                  <option value="6502A">Cebuano</option>
                  <option value="1199A">Celtic, nec ( Breton, Cornish, Manz)</option>
                  <option value="1100A">Celtic, nfd</option>
                  <option value="8299A">Central Aboriginal (NEC)</option>
                  <option value="8200A">Central Aboriginal (NFD)</option>
                  <option value="4299B">Chaldaean</option>
                  <option value="4203B">Chaldean Neo-Aramaic</option>
                  <option value="9299AV">Chiga</option>
                  <option value="7100B">Chin</option>
                  <option value="69996">Chin Daai</option>
                  <option value="6999E">Chin Falam</option>
                  <option value="6999D">Chin Haka</option>
                  <option value="6999F">Chin Khumi</option>
                  <option value="6999G">Chin Mara</option>
                  <option value="6999H">Chin Mro</option>
                  <option value="6999I">Chin Mun</option>
                  <option value="6999J">Chin Ngawn</option>
                  <option value="6999K">Chin Senthang</option>
                  <option value="6999L">Chin Teddim</option>
                  <option value="6999M">Chin Thado</option>
                  <option value="6999N">Chin Zome</option>
                  <option value="6999O">Chin Zotong</option>
                  <option value="7199A">Chinese, nec</option>
                  <option value="7100A">Chinese, nfd</option>
                  <option value="9209A">Comorian</option>
                  <option value="3503A">Croatian</option>
                  <option value="3601A">Czech</option>
                  <option value="3604A">Czechoslovakian, so described</option>
                  <option value="9299C">Dagbani</option>
                  <option value="9299AO">Daju, Dar Daju</option>
                  <option value="9299AP">Daju, Dar Sila</option>
                  <option value="1501A">Danish</option>
                  <option value="4105A">Dari</option>
                  <option value="8103A">Dhaangu</option>
                  <option value="8104A">Dhayyi</option>
                  <option value="5214A">Dhivehi</option>
                  <option value="8105A">Dhuwal-Dhuwala</option>
                  <option value="9216A">Dinka</option>
                  <option value="8106A">Djinang</option>
                  <option value="5199A">Dravidian, nec</option>
                  <option value="5100A">Dravidian, nfd</option>
                  <option value="1401A">Dutch</option>
                  <option value="7999B">Dzonkha</option>
                  <option value="7000A">EASTERN ASIAN LANGUAGES</option>
                  <option value="3000A">EASTERN EUROPEAN LANGUAGES</option>
                  <option value="3400A">East Slavic, nfd</option>
                  <option value="8699A">Eastern Aboriginal (NEC)</option>
                  <option value="8600A">Eastern Aboriginal (NFD)</option>
                  <option value="6199C">Eastern Kayah</option>
                  <option value="1201A">English</option>
                  <option value="1601A">Estonian</option>
                  <option value="9217A">Ewe</option>
                  <option value="1599B">Faeroese</option>
                  <option value="9301A">Fijian</option>
                  <option value="5217A">Fijian Hindustani</option>
                  <option value="6512A">Filipino</option>
                  <option value="3299A">Finnic, nec</option>
                  <option value="3200A">Finnic, nfd</option>
                  <option value="1602A">Finnish</option>
                  <option value="1401C">Flemish</option>
                  <option value="9299AB">Fon</option>
                  <option value="2101A">French</option>
                  <option value="1402A">Frisian</option>
                  <option value="9245A">Fulfulde</option>
                  <option value="9299AE">Fuliiru</option>
                  <option value="9299F">Fullah</option>
                  <option value="9299AR">Fur</option>
                  <option value="9218A">Ga</option>
                  <option value="1101A">Gaelic (Scotland)</option>
                  <option value="4902A">Georgian</option>
                  <option value="1301A">German</option>
                  <option value="9302A">Gilbertese</option>
                  <option value="9299K">Gio</option>
                  <option value="9299L">Grebo</option>
                  <option value="2201A">Greek</option>
                  <option value="8301A">Gugu Yalanji</option>
                  <option value="5202A">Gujarati</option>
                  <option value="8302A">Guugu Yimidhirr</option>
                  <option value="9299G">Hadiyigna</option>
                  <option value="6102A">Haka</option>
                  <option value="7102A">Hakka</option>
                  <option value="9221A">Harari</option>
                  <option value="9222A">Hausa</option>
                  <option value="9404A">Hawaiian English</option>
                  <option value="4100G">Hazaragi</option>
                  <option value="4204A">Hebrew</option>
                  <option value="92993">Hemba</option>
                  <option value="5203A" selected="selected">Hindi</option>
                  <option value="6201A">Hmong</option>
                  <option value="6299A">Hmong-Mien, nec</option>
                  <option value="6200A">Hmong-Mien, nfd</option>
                  <option value="7103A">Hokkien</option>
                  <option value="6999P">Hpon</option>
                  <option value="3301A">Hungarian</option>
                  <option value="6516A">Iban</option>
                  <option value="2399A">Iberian Romance, nec (includes Crioulo, Galaician, Ladino)</option>
                  <option value="2300A">Iberian Romance, nfd</option>
                  <option value="1502A">Icelandic</option>
                  <option value="9223A">Igbo</option>
                  <option value="6503A">Iiokano</option>
                  <option value="6517A">Ilonggo (Hiligaynon)</option>
                  <option value="0000A">Inadequately Described</option>
                  <option value="5000B">Indian</option>
                  <option value="5299A">Indo-Aryan, nec</option>
                  <option value="5200A">Indo-Aryan, nfd</option>
                  <option value="6504A">Indonesian</option>
                  <option value="9601A">Invented Languages</option>
                  <option value="4199A">Iranic, nec</option>
                  <option value="4100A">Iranic, nfd</option>
                  <option value="1102A">Irish</option>
                  <option value="2401A">Italian</option>
                  <option value="7201A">Japanese</option>
                  <option value="8206A">Jaru (Djaru)</option>
                  <option value="6518A">Javanese</option>
                  <option value="9299AG">Joba</option>
                  <option value="6199B">Kachin</option>
                  <option value="9299M">Kakwa</option>
                  <option value="8401A">Kalaw Lagaw Ya (Kalaw Kawa Ya)</option>
                  <option value="5101A">Kannada</option>
                  <option value="6103A">Karen</option>
                  <option value="6999Q">Karen Brek</option>
                  <option value="6999R">Karen Bwe</option>
                  <option value="6999S">Karen Gebe</option>
                  <option value="6999T">Karen Geko</option>
                  <option value="6999U">Karen Manumanaw</option>
                  <option value="6999V">Karen Paku</option>
                  <option value="6999W">Karen Pwo</option>
                  <option value="6999X">Karen S&#39;gaw</option>
                  <option value="6999Y">Karen Yinbaw</option>
                  <option value="6999Z">Karen Yintale</option>
                  <option value="69991">Karen Zayein</option>
                  <option value="8107A">Karrwa (Garrwa, Garawa)</option>
                  <option value="5215A">Kashmiri</option>
                  <option value="4100D">Kati</option>
                  <option value="4399B">Kazakh</option>
                  <option value="6301A">Khmer/Cambodian</option>
                  <option value="8207A">Kija (Gidya)</option>
                  <option value="9224A">Kikuyu</option>
                  <option value="9299N">Kinyarwanda / Rwanda</option>
                  <option value="9299O">Kirundi / Nyarwandwa / Rundi</option>
                  <option value="9299P">Kissi</option>
                  <option value="9502A">Kiwai</option>
                  <option value="5204A">Konkani</option>
                  <option value="92990">Kono (Sierra Leone)</option>
                  <option value="9299AF">Koongo</option>
                  <option value="7301A">Korean</option>
                  <option value="9299Q">Kpelle</option>
                  <option value="9299R">Krahn</option>
                  <option value="9205B">Kreole / Creole (African)</option>
                  <option value="8701B">Krieole</option>
                  <option value="9225A">Krio</option>
                  <option value="8701A">Kriol</option>
                  <option value="9299S">Kru</option>
                  <option value="8212A">Kukatha (Gugaja)</option>
                  <option value="8211A">Kukatha (Kokatha, Gugada)</option>
                  <option value="9299T">Kuku</option>
                  <option value="8108A">Kunwinjku (Gunwinggu)</option>
                  <option value="92994">Kuranko</option>
                  <option value="4101A">Kurdish</option>
                  <option value="8303A">Kuuku-Yau</option>
                  <option value="8208A">Kuurinji (Gurindji)</option>
                  <option value="9299AT">Laka</option>
                  <option value="9299AW">Lango</option>
                  <option value="6401A">Lao</option>
                  <option value="69992">Lashi</option>
                  <option value="2902A">Latin</option>
                  <option value="3101A">Latvian</option>
                  <option value="1302A">Letzeburgish</option>
                  <option value="9299AA">Liberian English</option>
                  <option value="9299U">Limba</option>
                  <option value="92992">Lingala</option>
                  <option value="7999F">Lisu</option>
                  <option value="3102A">Lithuanian</option>
                  <option value="92995">Loko</option>
                  <option value="92996">Lokoya</option>
                  <option value="9299V">Loma / Lorma</option>
                  <option value="9299AK">Luba-Kasai</option>
                  <option value="9226A">Luganda / Ganda</option>
                  <option value="9254A">Lumun (Kuku Lumun)</option>
                  <option value="9227A">Luo</option>
                  <option value="92997">Luwo</option>
                  <option value="3504A">Macedonian</option>
                  <option value="9299E">Madi</option>
                  <option value="9702A">Makaton</option>
                  <option value="6505A">Malay</option>
                  <option value="5102A">Malayalam</option>
                  <option value="2501A">Maltese</option>
                  <option value="4208A">Mandaean (Mandaic)</option>
                  <option value="7104A">Mandarin</option>
                  <option value="9299W">Mandingo</option>
                  <option value="9299X">Mano</option>
                  <option value="9303A">Maori (Cook Island)</option>
                  <option value="9304A">Maori (New Zealand)</option>
                  <option value="5205A">Marathi</option>
                  <option value="69993">Maru</option>
                  <option value="8111A">Maung</option>
                  <option value="9205A">Mauritian Creole</option>
                  <option value="9299Y">Mende</option>
                  <option value="8402A">Meryam Mir</option>
                  <option value="4299A">Middle Eastern Semitic Languages, nec</option>
                  <option value="4200A">Middle Eastern Semitic Languages, nfd</option>
                  <option value="7107A">Min Nan</option>
                  <option value="9299AC">Mina</option>
                  <option value="8213A">Miriwoong</option>
                  <option value="6303A">Mon</option>
                  <option value="6399A">Mon-Khmer, nec</option>
                  <option value="6300A">Mon-Khmer, nfd</option>
                  <option value="7902A">Mongolian</option>
                  <option value="92998">Moro</option>
                  <option value="9305A">Motu</option>
                  <option value="8112A">Murrinh-Patha</option>
                  <option value="8214A">Mutpurra (Mudburra)</option>
                  <option value="1000A">NORTHERN EUROPEAN LANGUAGES</option>
                  <option value="9306A">Nauruan</option>
                  <option value="9228A">Ndebele</option>
                  <option value="1401B">Nederlands</option>
                  <option value="5206A">Nepali</option>
                  <option value="8215A">Ngaatjatjara</option>
                  <option value="8113A">Ngangkikurungurr</option>
                  <option value="8501A">Ngarluma</option>
                  <option value="9307A">Niue</option>
                  <option value="0001A">Non-Verbal So Described</option>
                  <option value="8199A">Northern Aboriginal (NEC)</option>
                  <option value="8100A">Northern Aboriginal (NFD)</option>
                  <option value="1503A">Norwegian</option>
                  <option value="0002A">Not Stated</option>
                  <option value="9299AU">Nubi</option>
                  <option value="9231A">Nuer</option>
                  <option value="69994">Nung</option>
                  <option value="8114A">Nunggubuyu</option>
                  <option value="8216A">Nyangumarta</option>
                  <option value="9232A">Nyanja (Chichewa)</option>
                  <option value="8502A">Nyungar (Noongar)</option>
                  <option value="9000A">OTHER LANGUAGES</option>
                  <option value="9499A">Oceanian Pidgins And Creoles, nec</option>
                  <option value="9400A">Oceanian Pidgins And Creoles, nfd</option>
                  <option value="5216A">Oriya</option>
                  <option value="9206A">Oromo</option>
                  <option value="7999A">Other Eastern Asian Languages, nec</option>
                  <option value="3999A">Other Eastern European Languages, nec</option>
                  <option value="3900A">Other Eastern European Languages, nfd</option>
                  <option value="6999A">Other Southeast Asian Languages, nec</option>
                  <option value="5999A">Other Southern Asian Languages, nfd</option>
                  <option value="2999A">Other Southern European Languages, nec</option>
                  <option value="2900A">Other Southern European Languages, nfd</option>
                  <option value="4999A">Other Southwest and Central Asian Languages, nec</option>
                  <option value="9399A">Pacific Austronesian Languages, nec</option>
                  <option value="9300A">Pacific Austronesian Languages, nfd</option>
                  <option value="0000B">Pakistani</option>
                  <option value="6521A">Pampangan</option>
                  <option value="4103E">Panjsheri</option>
                  <option value="9599A">Papua New Guinea Papuan Languages, nec</option>
                  <option value="9501A">Papuan</option>
                  <option value="4100E">Parsun</option>
                  <option value="4102A">Pashto</option>
                  <option value="4106A">Persian (excluding Dari)</option>
                  <option value="4103A">Persian/Farsi/Dari</option>
                  <option value="8217A">Pintupi</option>
                  <option value="9403A">Pitcairnese</option>
                  <option value="8218A">Pitjantjatjara</option>
                  <option value="3602A">Polish</option>
                  <option value="2302A">Portuguese</option>
                  <option value="9299D">Pular / Fuuta Jalon</option>
                  <option value="5207A">Punjabi</option>
                  <option value="9299AH">Punu</option>
                  <option value="8115A">Rembarrnga</option>
                  <option value="8116A">Ritharrngu</option>
                  <option value="5201B">Rohingya</option>
                  <option value="3904A">Romanian</option>
                  <option value="3905A">Romany</option>
                  <option value="9312A">Rotuman</option>
                  <option value="3402A">Russian</option>
                  <option value="6000A">SOUTHEAST ASIAN LANGUAGES</option>
                  <option value="5000A">SOUTHERN ASIAN LANGUAGES</option>
                  <option value="2000A">SOUTHERN EUROPEAN LANGUAGES</option>
                  <option value="4000A">SOUTHWEST AND CENTRAL ASIAN LANGUAGES</option>
                  <option value="9308A">Samoan</option>
                  <option value="9299AJ">Sango</option>
                  <option value="6999B">Sasak</option>
                  <option value="1599A">Scandinavian, nec</option>
                  <option value="1500A">Scandinavian, nfd</option>
                  <option value="3505A">Serbian</option>
                  <option value="3507A">Serbo-Croatian/Yugoslavian, so described</option>
                  <option value="9238A">Seychelles Creole</option>
                  <option value="69995">Shan</option>
                  <option value="9233A">Shilluk</option>
                  <option value="9207A">Shona</option>
                  <option value="9799A">Sign Languages, nec</option>
                  <option value="9700A">Sign Languages,nfd</option>
                  <option value="5208A">Sindhi</option>
                  <option value="5211A">Sinhalese</option>
                  <option value="3603A">Slovak</option>
                  <option value="3506A">Slovene</option>
                  <option value="9405A">Solomon Islands Pijin</option>
                  <option value="9208A">Somali</option>
                  <option value="9299AI">Songo</option>
                  <option value="3500A">South Slavic, nfd</option>
                  <option value="6500A">Southeast Asian Austronesian Languages</option>
                  <option value="6599A">Southeast Asian Austronesian Languages, nec</option>
                  <option value="2303A">Spanish</option>
                  <option value="5000C">Sri Lankan</option>
                  <option value="9299Z">Susu</option>
                  <option value="9211A">Swahili</option>
                  <option value="1504A">Swedish</option>
                  <option value="7999C">Szi</option>
                  <option value="6506A">Tagalog (Filipino)</option>
                  <option value="6499A">Tai, nec</option>
                  <option value="6400A">Tai, nfd</option>
                  <option value="5103A">Tamil</option>
                  <option value="4303A">Tatar</option>
                  <option value="5104A">Telugu</option>
                  <option value="9299J">Temne / Themne</option>
                  <option value="7105A">Teochew</option>
                  <option value="6507A">Tetum</option>
                  <option value="6402A">Thai</option>
                  <option value="7901A">Tibetan</option>
                  <option value="9234A">Tigre</option>
                  <option value="9235A">Tigrinya</option>
                  <option value="6508A">Timorese</option>
                  <option value="8117A">Tiwi</option>
                  <option value="9401A">Tok Pisin</option>
                  <option value="9313A">Tokelauan</option>
                  <option value="9311A">Tongan</option>
                  <option value="8400A">Torres Strait (NFD)</option>
                  <option value="8702A">Torres Strait Creole (Broken)</option>
                  <option value="9236A">Tswana</option>
                  <option value="5105A">Tulu</option>
                  <option value="4399A">Turkic, nec</option>
                  <option value="4300A">Turkic, nfd</option>
                  <option value="4301A">Turkish</option>
                  <option value="4304A">Turkmen</option>
                  <option value="9314A">Tuvaluan</option>
                  <option value="9203B">Twi (Akan)</option>
                  <option value="3403A">Ukrainian</option>
                  <option value="3500B">Unspec.Fmr.Yugoslav Language</option>
                  <option value="5212A">Urdu</option>
                  <option value="4305A">Uygur / Uyghur</option>
                  <option value="4306A">Uzbek</option>
                  <option value="92991">Vai</option>
                  <option value="6302A">Vietnamese</option>
                  <option value="4100F">Waigali</option>
                  <option value="8221A">Walmajarri (Walmadjari)</option>
                  <option value="8223A">Warlpiri</option>
                  <option value="8222A">Warumungu (Warumunga)</option>
                  <option value="1103A">Welsh</option>
                  <option value="8599A">West Coast Aboriginal (NEC)</option>
                  <option value="8500A">West Coast Aboriginal (NFD)</option>
                  <option value="3600A">West Slavic, nfd</option>
                  <option value="8304A">Wik-Mungkan</option>
                  <option value="7106A">Wu</option>
                  <option value="9237A">Xhosa</option>
                  <option value="9299AL">Yakoma</option>
                  <option value="8225A">Yankuntjatjara</option>
                  <option value="8118A">Yanyuwa (Anula)</option>
                  <option value="9315A">Yapese</option>
                  <option value="1303A">Yiddish</option>
                  <option value="8503A">Yindjibarndi</option>
                  <option value="9212A">Yoruba</option>
                  <option value="8224A">Yulparija</option>
                  <option value="9299AS">Zaghawa</option>
                  <option value="7999D">Zaiwa</option>
                  <option value="9299AN">Zande</option>
                  <option value="69997">Zophei</option>
                  <option value="9213A">Zulu</option>
                </select>
              </div>
            </div>
          </div>
    </div>
        </form>

      </div>
      <div class="tile-action">
      </div>
    </div>
  </div>
</template>

<script>
import baseQ from '@/components/questions/base'
export default {
  name: 'languageQ',
  extends: baseQ
}
</script>



// WEBPACK FOOTER //
// language.vue?76db576c